import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { getCookie } from "typescript-cookie";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetCitizenshipListQuery } from "../../redux/api/handBooksApi/citizenshipApi";
import { EntCitizenship } from "../../models/citizenship/citizenship";
import { EntInitialFilter } from "../../models/filters/initialFilter";

interface IProps {
  onChange?: (value: number) => void;
  value?: number|undefined|null;
}

const SelectCitizenship = (props: IProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>([]);

  const [getData] = useLazyGetCitizenshipListQuery();
  const {
	fetching,
	data,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntCitizenship, EntInitialFilter>({
	initialFilter: new EntInitialFilter(),
	query: getData
  });

  useEffect(() => {
	const options = Array.from(new Set(data)).map((a) => {
	  return { label: getCookie('i18next') === 'ky' ? `${ a.countryKy }` : `${ a.countryRu }`, value: a.id ?? '' };
	});
	setOptions(options);
  }, [data]);

  const search = (value?: string) => {
	if (!value) return;
	const filter = new EntInitialFilter();
	filter.name = value;
	setFilter(filter);
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }
  const clear = () => {
	const filter = new EntInitialFilter();
	filter.name = null;
	setFilter(filter);
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  return (
	<Select
	  placeholder={ t("msg.selectPlaceholder") }
	  onClear={ clear }
	  onSearch={ search }
	  onPopupScroll={ scrollHandler }
	  loading={ fetching }
	  value={ props.value }
	  onChange={ props.onChange }
	  options={ options }
	  filterOption={ defaultFilterOption }
	  showSearch
	  allowClear
	  dropdownRender={ (menu) => (
		<Spin spinning={ fetching }>
		  { menu }
		</Spin>
	  ) }
	/>
  );
};

export default SelectCitizenship;